import { render, staticRenderFns } from "./TicketTagPickerDialog.vue?vue&type=template&id=58986a6a&scoped=true"
import script from "./TicketTagPickerDialog.vue?vue&type=script&lang=js"
export * from "./TicketTagPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./TicketTagPickerDialog.vue?vue&type=style&index=0&id=58986a6a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58986a6a",
  null
  
)

export default component.exports